"use strict";

exports.__esModule = true;
exports.forceReflow = void 0;
var forceReflow = exports.forceReflow = function forceReflow(node) {
  return node.scrollTop;
};